import { Input } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { ChangeEvent } from 'react';

type Props = {
	name: string;
	label: string;
	value: number | string;
	placeholder?: string;
	required: boolean;
	isError: boolean;
	onChange: (value: string) => void;
	prefix?: any;
	suffix?: any;
	disabled?: boolean;
	size?: SizeType;
	showLabel?: boolean;
	style?: any;
	isViewOnly?: boolean;
	onBlur?: (formattedValue: string) => void;
	is8hoursRequired?: boolean;
	isForeman?: boolean;
};

const InputTimeLogsHoursField = (props: Props) => {
	const {
		name,
		label,
		value,
		placeholder,
		isError = false,
		prefix = null,
		suffix = null,
		// regex,
		required = false,
		onChange,
		disabled = false,
		// type = 'text',
		// helperText = 'Invalid field',
		// formatter,
		// parser,
		size = 'large',
		showLabel = false,
		onBlur,
		style,
		isViewOnly,
		is8hoursRequired = false,
		isForeman = false,
	} = props;
	const handleChange = (value: string) => {
		let inputValue = String(value);

		// Remove non-digit characters
		inputValue = inputValue.replace(/\D/g, '');

		// Restrict to 4 digits
		if (inputValue.length > 4) {
			inputValue = inputValue.slice(0, 4);
		}

		// Format inputValue as HH:MM
		if (inputValue.length > 2) {
			inputValue = `${inputValue.slice(0, 2)}:${inputValue.slice(2)}`;
		}

		onChange(inputValue);
	};

	const handleBlur = (value: string) => {
		let formattedValue = value.replace(/[^\d:]/g, '');
		const regular_minutes = isForeman ? 720 : 480;
		// Handle cases with or without colon
		const parts = formattedValue.split(':');
		let hours = parts[0] || '00';
		let minutes = parts[1] || '00';

		// Ensure hours and minutes are numeric
		let h = parseInt(hours, 10) || 0;
		let m = parseInt(minutes, 10) || 0;

		// Convert to total minutes
		let totalMinutes = h * 60 + m;

		// ✅ Cap to 24h = 1440 minutes
		if (totalMinutes > 1440) totalMinutes = 1440;

		if (is8hoursRequired && totalMinutes < regular_minutes)
			totalMinutes = regular_minutes;
		// Recalculate hours & minutes
		h = Math.floor(totalMinutes / 60);
		m = totalMinutes % 60;

		// Format back to HH:MM
		formattedValue =
			String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');

		if (!formattedValue) {
			formattedValue = '00:00';
		}

		onChange(formattedValue);

		if (onBlur) {
			onBlur(formattedValue);
		}
	};

	return (
		<div className="input-field">
			{showLabel && label && (
				<p
					className="label"
					style={{ marginBottom: `${isViewOnly ? '5px' : ''}` }}
				>
					{label}{' '}
					{required && !isViewOnly && <span className="red">*</span>}
				</p>
			)}

			{isViewOnly ? (
				<p>{value} hrs</p>
			) : (
				<div>
					<Input
						name={name}
						status={isError ? 'error' : ''}
						placeholder={placeholder}
						prefix={prefix}
						suffix={suffix}
						value={value}
						required={required}
						onChange={(e: any) => {
							handleChange(e.target.value);
						}}
						onBlur={(e: ChangeEvent<HTMLInputElement>) =>
							handleBlur(e.target.value)
						}
						disabled={disabled}
						size={size}
						style={{ width: '100%', ...style }}
					/>
				</div>
			)}
		</div>
	);
};

export default InputTimeLogsHoursField;
